import React from "react";
import PropTypes from "prop-types";
import { SubCategoryList, SubCategory } from "./styled-components";

const Category = ({ subCategories }) => {
  return (
    <SubCategoryList>
      {subCategories.map(({ target = "_self", title, url }) => (
        <SubCategory href={url} key={`${title}-${url}`} target={target}>
          {title}
        </SubCategory>
      ))}
    </SubCategoryList>
  );
};

Category.propTypes = {
  subCategories: PropTypes.arrayOf(
    PropTypes.shape({
      className: PropTypes.string,
      target: PropTypes.string,
      title: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default Category;
